// extracted by mini-css-extract-plugin
module.exports =  {"root":"JQvVl2yADyUk4H6ZQsan"};